<ion-header><app-navheader></app-navheader></ion-header>
<ion-content class="no-ion-padding">
  <div class="wrapper">
    <ion-list>
      <form #loginForm ="ngForm">
        <ion-item lines="none" class="firstinput blue-item ion-no-padding">
          <ion-label position="stacked">{{'ACCOUNT.PROFILE_EDIT.NICKNAME_CHANGE' | translate}}</ion-label>
          <ion-input type="text" [(ngModel)] = "model.nickname" name="nickname" id="nickname" #nickname = "ngModel"></ion-input>
        </ion-item>
        <ion-button class="connect" (click)="changeNickName()">{{'ACCOUNT.PROFILE_EDIT.BUTTON' | translate}}</ion-button>
      </form>
    </ion-list>

    <ion-list>
      <form #loginForm ="ngForm">
        <ion-item lines="none" class="firstinput blue-item ion-no-padding">
          <ion-label position="stacked">{{'ACCOUNT.PROFILE_EDIT.DETAILS.PRENOM' | translate}}</ion-label>
          <ion-input type="text" [(ngModel)] = "model.lastName" name="lastName" id="lastName" #lastName = "ngModel"></ion-input>
        </ion-item>
        <ion-item lines="none" class="firstinput blue-item ion-no-padding">
          <ion-label position="stacked">{{'ACCOUNT.PROFILE_EDIT.DETAILS.SUBSCRIPTION_NUMBER' | translate}}</ion-label>
          <ion-input type="text" [(ngModel)] = "model.subscriber_number" name="subscriber_number" id="subscriber_number" maxlength="9" #subscriber_number = "ngModel"></ion-input>
        </ion-item>
        <ion-button class="connect" (click)="openConfirmPopUp()">{{'ACCOUNT.PROFILE_EDIT.BUTTON' | translate}}</ion-button>
      </form>
    </ion-list>
    <div class="thematicfiles-wrapper clear">
      <div class="change-avatar m-auto">{{'ACCOUNT.PROFILE_EDIT.AVATAR_CHANGE' | translate}}</div>
      <div class="thematicfile-container m-auto" *ngFor="let avatar of avatars">
        <img src="{{avatar.avatar_path}}" (click)= "chooseAvatar(avatar.avatar_id)"/>
      </div>
    </div>
  </div>
  <app-cookie-info></app-cookie-info>
</ion-content>
<ion-footer><app-bottom-menu></app-bottom-menu></ion-footer>
<app-pop-up [show]="tempPopUp" [data]="popup" (popUpNotify)="onNotifyPopUp($event)" #temppopup></app-pop-up>

